import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-offline-page',
  templateUrl: './offline-page.component.html',
  styleUrls: ['./offline-page.component.scss']
})
export class OfflinePageComponent {
  constructor(
    private router: Router
  ) { }

  onOffline() {
    if(navigator.onLine){
      this.router.navigate(['/signin']);
    }
  }
}
